import React, { useState } from "react"
import { Link } from "react-router-dom"
import { LogoWithText } from "./logo-with-text"
import { useAuth } from "../../hooks/use-auth"
import { Button } from "./button"
import { Key } from "lucide-react"
import { PinManagementModal } from "../admin/pin-management-modal"
import { navigationClick } from "../../lib/analytics-factory"

export function Footer() {
  const { isAdmin, isAuthenticated } = useAuth()
  const [showPinModal, setShowPinModal] = useState(false)
  const currentYear = new Date().getFullYear()

  const handleManagePins = (e: React.MouseEvent<HTMLButtonElement>) => {
    navigationClick('manage_pins_footer')(e);
    setShowPinModal(true)
  }

  return (
    <>
      <footer className="relative z-10 border-t bg-background">
        <div className="container py-8">
          <div className="flex flex-col items-center gap-6 md:flex-row md:justify-between">
            <div className="flex flex-col items-center gap-4 md:items-start">
              <LogoWithText />
              <p className="text-sm text-muted-foreground">
                Embedding Systems and Intelligence
              </p>
            </div>
            
            <div className="flex flex-col items-center gap-4 md:items-end">
              <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3 w-full text-center md:justify-end">
                <Link 
                  to="/privacy" 
                  className="text-sm text-muted-foreground hover:text-foreground"
                  onClick={navigationClick("footer_privacy")}
                >
                  Privacy Policy
                </Link>
                <Link 
                  to="/terms" 
                  className="text-sm text-muted-foreground hover:text-foreground"
                  onClick={navigationClick("footer_terms")}
                >
                  Terms of Service
                </Link>
                {isAuthenticated && isAdmin && (
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={handleManagePins}
                    className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-2 h-auto p-0"
                  >
                    <Key className="h-4 w-4" />
                    Manage PINs
                  </Button>
                )}
              </nav>
              <p className="text-sm text-muted-foreground">
                © {currentYear} Syllepsis Ltd. All rights reserved.
              </p>
              <p className="text-sm text-muted-foreground text-center md:text-right">
                Company No. 16175286 | 71-75 Shelton Street, London WC2H 9JQ
              </p>
            </div>
          </div>
        </div>
      </footer>

      {isAdmin && (
        <PinManagementModal
          open={showPinModal}
          onClose={() => setShowPinModal(false)}
        />
      )}
    </>
  )
}